import { useMutation, useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { IFederalStateLogin } from '../../Interfaces/IFederalStateLogin';

export const useGetFederalStateLogins = () => {
  const {
    data: federalStateLogins,
    isLoading: isFederalStateLogins,
    refetch: refetchFederalStateLogins,
  } = useQuery<IFederalStateLogin[]>({
    queryKey: ['federalstatelogin'],
    queryFn: () => customFetcher({ endpoint: '/federalstatelogin' }),
  });

  return {
    federalStateLogins,
    isFederalStateLogins,
    refetchFederalStateLogins,
  };
};

export const useCreateFedearalStateLogin = () => {
  const {
    mutateAsync: createFederalStateLogin,
    isPending: isPendingCreateFederalStateLogin,
  } = useMutation({
    mutationFn: (currentObject: IFederalStateLogin) =>
      customFetcher({
        endpoint: '/federalstatelogin',
        method: 'POST',
        body: currentObject,
      }),
  });

  return {
    createFederalStateLogin,
    isPendingCreateFederalStateLogin,
  };
};

export const useUpdateFedearalStateLogin = () => {
  const {
    mutateAsync: updateFederalStateLogin,
    isPending: isPendingUpdateFederalStateLogin,
  } = useMutation({
    mutationFn: (currentObject: IFederalStateLogin) =>
      customFetcher({
        endpoint: '/federalstatelogin',
        method: 'PUT',
        body: currentObject,
      }),
  });

  return {
    updateFederalStateLogin,
    isPendingUpdateFederalStateLogin,
  };
};

/**
 * Dem aktuellen Benutzer zugeordnete (persönliche) Grundbuch-Zugänge — ohne
 * Passwort. Quelle für die Zugangs-Auswahl beim Abruf / bei der Nachverfolgung.
 */
export const useGetLandRegisterAccesses = () => {
  const {
    data: landRegisterAccesses,
    isLoading: isLoadingLandRegisterAccesses,
    refetch: refetchLandRegisterAccesses,
  } = useQuery<IFederalStateLogin[]>({
    queryKey: ['landregister', 'access'],
    queryFn: () => customFetcher({ endpoint: '/landregister/access' }),
  });

  return {
    landRegisterAccesses,
    isLoadingLandRegisterAccesses,
    refetchLandRegisterAccesses,
  };
};

export const useCheckFederalStateLogin = () => {
  const {
    mutateAsync: checkFederalStateLogin,
    isPending: isPendingCheckFederalStateLogin,
  } = useMutation({
    mutationFn: (currentObject: IFederalStateLogin[]) =>
      customFetcher({
        endpoint: '/landregister/checklogin',
        method: 'POST',
        body: currentObject,
      }),
  });

  return {
    checkFederalStateLogin,
    isPendingCheckFederalStateLogin,
  };
};
